// CrackersContext.js
import React, { createContext, useState, useEffect } from "react";

export const CrackersContext = createContext();

export const CrackersProvider = ({ children }) => {

  const [serviceCommonData, setServiceCommonData] = useState(() => {
    const cachedServiceCommonsData = localStorage.getItem("serviceCommonData");
    if(cachedServiceCommonsData) {
      if((typeof cachedServiceCommonsData).toLowerCase() === "object") {
        return cachedServiceCommonsData;
      } else {
        return JSON.parse(cachedServiceCommonsData);  
      }
    } else {
      return JSON.parse("{}");
    }
  })

  const [agents, setAgents] = useState(() => {
    const cachedAgents = localStorage.getItem("agents");
    return cachedAgents ? JSON.parse(cachedAgents) : [];
  });

  const [crackersData, setCrackersData] = useState(() => {
    const cachedData = localStorage.getItem("crackersData");
    return cachedData ? JSON.parse(cachedData) : null;
  });

  const [agentCode, setAgentCode] = useState(() => {
    const cachedAgentCode = localStorage.getItem("agentCode");
    return cachedAgentCode || null;
  });

  const [crackersFilter, setCrackersFilter] = useState(() => {
    const cachedFilter = localStorage.getItem("crackersFilter");
    return cachedFilter ? JSON.parse(cachedFilter) : [];
  });

  const [crackersCategory, setCrackersCategory] = useState(() => {
    const cachedCategory = localStorage.getItem("crackerscategory");
    return cachedCategory ? JSON.parse(cachedCategory) : [];
  });

  const [userInfo, setUserInfo] = useState(() => {
    const cachedUserInfo = localStorage.getItem("userInfo");
    return cachedUserInfo ? JSON.parse(cachedUserInfo) : null;
  });

  const [landingPage, setLandingPage] = useState(() => {
    const cachedLandingPage = localStorage.getItem("landingPage");
    return cachedLandingPage ? cachedLandingPage : "/";
  });

  const [cartsInfo, setCartsInfo] = useState(() =>{
    const cachedCartsInfo = localStorage.getItem("cartsInfo");
    return cachedCartsInfo ? cachedCartsInfo : {};
  });

  const [carts, setCarts] = useState(() => {
    const cachedCarts = localStorage.getItem("carts");
    return cachedCarts ? cachedCarts : [];
  });

  const [showErrorToastStatus, setShowErrorToastStatus] = useState(() => {
    const cachedErrorToastStatus = localStorage.getItem("showErrorToastStatus");
    return false;
  });

  const [toastBody, setToastBody] = useState(() => {
    const cachedToastBody = localStorage.getItem("toastBody");
    return cachedToastBody ? cachedToastBody : {"toastType" : "light", "toastTitle" : "", "toastMessage" : "" };
  });

  const [activePage, setActivePage] = useState(() => {
    const cachedActivePage = localStorage.getItem("activePage");
    return cachedActivePage ? cachedActivePage : 1;
  });

  const [activeCart, setActiveCart] = useState(() => {
    const cachedActiveCart = localStorage.getItem("activeCart");
    return cachedActiveCart ? cachedActiveCart : "Default";
  });

  const [cartBtnViewable, setCartBtnViewable] = useState(() => {
    const cachedCartBtnViewable = localStorage.getItem("cartBtnViewable");
    return cachedCartBtnViewable ? cachedCartBtnViewable : false;
  });

  const [browserCart, setBrowserCart] = useState(() => {
    const cachedBrowserCart = localStorage.getItem("browserCart");
    // if(cachedBrowserCart) {
    //   try {
    //     return JSON.parse(cachedBrowserCart);
    //   } catch (err) {
    //     console.error("Invalid JSON in Browser cart", err);
    //     return JSON.parse("[]");
    //   }
    // } else {
    //   return JSON.parse("[]");
    // }
    return cachedBrowserCart ? cachedBrowserCart : JSON.stringify([]);
  });

  const [isZeroCasePage, setIsZeroCasePage] = useState(() => {
    const cachedIsZeroCasePage = localStorage.getItem("isZeroCasePage");
    return cachedIsZeroCasePage ? cachedIsZeroCasePage : false;
  });

  useEffect(() => {
    localStorage.setItem("serviceCommonData", JSON.stringify(serviceCommonData));
    localStorage.setItem("agents", JSON.stringify(agents));
    localStorage.setItem("crackersData", JSON.stringify(crackersData));
    localStorage.setItem("agentCode", agentCode);
    localStorage.setItem("crackersFilter", JSON.stringify(crackersFilter));
    localStorage.setItem("crackersCategory", JSON.stringify(crackersCategory));
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    localStorage.setItem("landingPage", landingPage);
    localStorage.setItem("cartsInfo", cartsInfo);
    localStorage.setItem("carts", carts);
    localStorage.setItem("showErrorToastStatus", showErrorToastStatus);
    localStorage.setItem("toastBody", toastBody);
    localStorage.setItem("activePage", activePage);
    localStorage.setItem("cartBtnViewable", cartBtnViewable);
    localStorage.setItem("browserCart", browserCart);
    localStorage.setItem("activeCart", activeCart);
    localStorage.setItem("isZeroCasePage", isZeroCasePage);
  }, [serviceCommonData, agents, crackersData, agentCode, crackersFilter, crackersCategory, userInfo, landingPage, cartsInfo, carts, showErrorToastStatus, activePage, cartBtnViewable, browserCart, activeCart, isZeroCasePage]);

  return (
    <CrackersContext.Provider
      value={{  serviceCommonData, setServiceCommonData,
                agents, setAgents,
                crackersData, setCrackersData,
                agentCode, setAgentCode,
                crackersFilter, setCrackersFilter,
                crackersCategory, setCrackersCategory,
                userInfo, setUserInfo,
                landingPage, setLandingPage,
                cartsInfo, setCartsInfo,
                carts, setCarts,
                showErrorToastStatus, setShowErrorToastStatus,
                toastBody, setToastBody,
                activePage, setActivePage,
                browserCart, setBrowserCart,
                activeCart, setActiveCart,
                isZeroCasePage, setIsZeroCasePage
              }}
    >
      {children}
    </CrackersContext.Provider>
  );
};
